var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluentEmojiPotOfFood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-emoji:pot-of-food"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.875 16.4424C1.875 15.4478 2.27009 14.494 2.97335 13.7907C3.67661 13.0875 4.63044 12.6924 5.625 12.6924H11.25V20.1924H5.625C4.63044 20.1924 3.67661 19.7973 2.97335 19.094C2.27009 18.3908 1.875 17.4369 1.875 16.4424ZM5.625 14.5674C5.12772 14.5674 4.65081 14.7649 4.29917 15.1166C3.94754 15.4682 3.75 15.9451 3.75 16.4424C3.75 16.9397 3.94754 17.4166 4.29917 17.7682C4.65081 18.1198 5.12772 18.3174 5.625 18.3174H9.375V14.5674H5.625Z",
    fill: "url(#paint0_linear_434_3390)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 12.6924H24.375C25.3696 12.6924 26.3234 13.0875 27.0266 13.7907C27.7299 14.494 28.125 15.4478 28.125 16.4424C28.125 17.4369 27.7299 18.3908 27.0266 19.094C26.3234 19.7973 25.3696 20.1924 24.375 20.1924H18.75V12.6924ZM20.625 14.5674V18.3174H24.375C24.8723 18.3174 25.3492 18.1198 25.7008 17.7682C26.0525 17.4166 26.25 16.9397 26.25 16.4424C26.25 15.9451 26.0525 15.4682 25.7008 15.1166C25.3492 14.7649 24.8723 14.5674 24.375 14.5674H20.625Z",
    fill: "url(#paint1_linear_434_3390)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_f_434_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25169 14.7529C3.87857 15.0023 3.48669 15.4711 3.48669 16.4714C3.48669 17.2092 3.81669 17.7061 4.23201 18.037C4.67638 18.3914 5.17888 18.5226 5.39826 18.5226H6.89919C7.08567 18.5226 7.26452 18.5967 7.39638 18.7286C7.52824 18.8604 7.60232 19.0393 7.60232 19.2258C7.60232 19.4122 7.52824 19.5911 7.39638 19.7229C7.26452 19.8548 7.08567 19.9289 6.89919 19.9289H5.39826C4.82638 19.9289 4.02013 19.6664 3.35544 19.1367C2.95162 18.821 2.62638 18.4161 2.40518 17.9537C2.18398 17.4913 2.07283 16.9839 2.08044 16.4714C2.08044 15.0108 2.69919 14.0995 3.46982 13.5839C4.0265 13.2201 4.67431 13.0203 5.33919 13.0073H7.16263V14.4136H5.34013C4.95368 14.4267 4.57702 14.544 4.25169 14.7529ZM7.86669 13.7104C7.86669 13.8969 7.79262 14.0758 7.66075 14.2076C7.52889 14.3395 7.34911 14.4136 7.16263 14.4136L7.16357 13.7104L7.16263 13.0073C7.25497 13.0073 7.3464 13.0255 7.43171 13.0608C7.51701 13.0962 7.59452 13.148 7.65982 13.2133C7.72511 13.2786 7.7769 13.3561 7.81223 13.4414C7.84757 13.5267 7.86669 13.6181 7.86669 13.7104Z",
    fill: "url(#paint2_linear_434_3390)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_f_434_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1665 14.8111C26.5387 15.1336 26.9099 15.6633 26.9099 16.5305C26.9099 17.3696 26.5752 17.843 26.2424 18.1196C25.8805 18.4196 25.0752 18.5227 24.8427 18.5227H23.3859C23.1994 18.5227 23.0205 18.5968 22.8887 18.7286C22.7568 18.8605 22.6827 19.0393 22.6827 19.2258C22.6827 19.4123 22.7568 19.5911 22.8887 19.723C23.0205 19.8549 23.1994 19.9289 23.3859 19.9289H24.8427C25.3771 19.9289 26.1337 19.7274 26.7674 19.2014C27.4293 18.6521 27.9205 17.7783 27.9205 16.5296C27.9205 15.2227 27.3693 14.3161 26.714 13.748C26.2312 13.3299 25.5562 12.9558 24.8999 12.9558H23.1309V14.2411H24.808C25.2693 14.2411 25.8909 14.573 26.1655 14.8102L26.1665 14.8111ZM22.4277 13.6589C22.4277 14.0471 22.7418 14.2411 23.1309 14.2411V12.9558C22.9444 12.9558 22.7655 13.0308 22.6337 13.1627C22.5018 13.2945 22.4277 13.4725 22.4277 13.6589Z",
    fill: "url(#paint3_linear_434_3390)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.5625 13.6299H23.4375V20.1924C23.4375 22.4301 22.5486 24.5763 20.9662 26.1586C19.3839 27.7409 17.2378 28.6299 15 28.6299C12.7622 28.6299 10.6161 27.7409 9.03379 26.1586C7.45145 24.5763 6.5625 22.4301 6.5625 20.1924V13.6299Z",
    fill: "url(#paint4_linear_434_3390)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15 22.5661C19.6599 22.5661 23.4375 18.6769 23.4375 13.8793C23.4375 9.08163 19.6599 5.19238 15 5.19238C10.3401 5.19238 6.5625 9.08163 6.5625 13.8793C6.5625 18.6769 10.3401 22.5661 15 22.5661Z",
    fill: "url(#paint5_linear_434_3390)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.9921 21.5986C19.2518 21.5986 22.7049 18.1358 22.7049 13.8643C22.7049 9.59268 19.2518 6.12988 14.9921 6.12988C10.7324 6.12988 7.2793 9.59268 7.2793 13.8643C7.2793 18.1358 10.7324 21.5986 14.9921 21.5986Z",
    fill: "url(#paint6_linear_434_3390)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.9921 21.5996C19.2518 21.5996 22.7049 18.2677 22.7049 14.1577C22.7049 10.0477 19.2518 6.71582 14.9921 6.71582C10.7324 6.71582 7.2793 10.0477 7.2793 14.1577C7.2793 18.2677 10.7324 21.5996 14.9921 21.5996Z",
    fill: "url(#paint7_radial_434_3390)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    filter: "url(#filter2_f_434_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.7508 15.6079C18.148 15.6079 17.0802 16.4826 16.9011 17.2654C16.8739 17.3854 16.9705 17.4885 17.0942 17.4951C17.412 17.5129 18.042 17.541 18.7508 17.541C19.4595 17.541 20.0895 17.5129 20.4074 17.4951C20.5311 17.4885 20.6267 17.3854 20.5977 17.2654C20.4186 16.536 19.422 15.6069 18.7508 15.6069V15.6079Z",
    fill: "#EB502E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    filter: "url(#filter3_f_434_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M15.0008 18.4785C14.398 18.4785 13.3302 19.3541 13.1511 20.1369C13.1239 20.2569 13.2205 20.36 13.3442 20.3666C13.662 20.3835 14.292 20.4116 15.0008 20.4116C15.7095 20.4116 16.3395 20.3835 16.6574 20.3666C16.7811 20.36 16.8767 20.2569 16.8477 20.1369C16.6686 19.4066 15.672 18.4775 15.0008 18.4775V18.4785Z",
    fill: "#EB502E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.7492 15.5049C18.2924 15.5047 17.8513 15.6713 17.5086 15.9734C17.166 16.2755 16.9454 16.6923 16.8883 17.1455C16.8724 17.2739 16.9792 17.3799 17.1086 17.3799H20.3899C20.5192 17.3799 20.6261 17.2739 20.6102 17.1455C20.5531 16.6923 20.3325 16.2755 19.9898 15.9734C19.6472 15.6713 19.206 15.5047 18.7492 15.5049Z",
    fill: "url(#paint8_radial_434_3390)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    filter: "url(#filter4_f_434_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8612 11.9011C16.8612 10.8821 17.6918 10.0552 18.7174 10.0552C19.6624 10.0552 20.4424 10.7583 20.5578 11.6677C20.5737 11.7961 20.4678 11.9021 20.3384 11.9021L16.8612 11.9011ZM15.0349 11.6696C15.0874 11.4712 15.204 11.2958 15.3667 11.1708C15.5294 11.0458 15.7289 10.9782 15.934 10.9786C16.4459 10.9786 16.8612 11.3911 16.8612 11.9011H15.2403C15.1109 11.9011 15.0031 11.7942 15.0349 11.6696Z",
    fill: "#F15C31"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M18.75 9.87988C18.2527 9.87988 17.7758 10.0774 17.4242 10.4291C17.0725 10.7807 16.875 11.2576 16.875 11.7549H20.3906C20.52 11.7549 20.6269 11.6489 20.6109 11.5205C20.5538 11.0673 20.3333 10.6505 19.9906 10.3484C19.6479 10.0463 19.2068 9.87973 18.75 9.87988Z",
    fill: "url(#paint9_radial_434_3390)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M15.9382 10.8174C15.7298 10.8171 15.5273 10.8863 15.3626 11.014C15.1979 11.1416 15.0805 11.3205 15.0288 11.5224C14.9978 11.648 15.1057 11.7549 15.235 11.7549H16.8757C16.8757 11.5062 16.7769 11.2678 16.6011 11.092C16.4253 10.9162 16.1868 10.8174 15.9382 10.8174Z",
    fill: "url(#paint10_radial_434_3390)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    filter: "url(#filter5_f_434_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M11.2465 17.541C10.8312 17.541 10.4824 17.841 10.384 18.246C10.354 18.3716 10.4618 18.4785 10.5902 18.4785H11.9027C12.0312 18.4785 12.139 18.3716 12.109 18.246C12.0105 17.841 11.6618 17.541 11.2465 17.541Z",
    fill: "#F1512A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11.2507 17.3799C11.0422 17.3797 10.8396 17.449 10.6749 17.5768C10.5102 17.7047 10.3928 17.8838 10.3413 18.0858C10.3103 18.2105 10.4182 18.3174 10.5475 18.3174H11.9538C12.0832 18.3174 12.191 18.2105 12.16 18.0858C12.1085 17.8838 11.9912 17.7047 11.8265 17.5768C11.6618 17.449 11.4592 17.3797 11.2507 17.3799Z",
    fill: "url(#paint11_radial_434_3390)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M14.9992 18.3174C14.5424 18.3172 14.1013 18.4838 13.7586 18.7859C13.416 19.088 13.1954 19.5048 13.1383 19.958C13.1224 20.0864 13.2292 20.1924 13.3586 20.1924H16.6399C16.7692 20.1924 16.8761 20.0864 16.8602 19.958C16.8031 19.5048 16.5825 19.088 16.2398 18.7859C15.8972 18.4838 15.456 18.3172 14.9992 18.3174Z",
    fill: "url(#paint12_radial_434_3390)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    filter: "url(#filter6_f_434_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M9.2207 16.3179C9.60903 16.3179 9.92383 16.0031 9.92383 15.6147C9.92383 15.2264 9.60903 14.9116 9.2207 14.9116C8.83238 14.9116 8.51758 15.2264 8.51758 15.6147C8.51758 16.0031 8.83238 16.3179 9.2207 16.3179Z",
    fill: "#E44F2E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    filter: "url(#filter7_f_434_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M19.5605 14.4248C19.9489 14.4248 20.2637 14.11 20.2637 13.7217C20.2637 13.3334 19.9489 13.0186 19.5605 13.0186C19.1722 13.0186 18.8574 13.3334 18.8574 13.7217C18.8574 14.11 19.1722 14.4248 19.5605 14.4248Z",
    fill: "#E44F2E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M9.375 16.208C9.76333 16.208 10.0781 15.8932 10.0781 15.5049C10.0781 15.1166 9.76333 14.8018 9.375 14.8018C8.98667 14.8018 8.67188 15.1166 8.67188 15.5049C8.67188 15.8932 8.98667 16.208 9.375 16.208Z",
    fill: "url(#paint13_radial_434_3390)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    filter: "url(#filter8_f_434_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M13.9746 9.73364C14.3629 9.73364 14.6777 9.41884 14.6777 9.03052C14.6777 8.64219 14.3629 8.32739 13.9746 8.32739C13.5863 8.32739 13.2715 8.64219 13.2715 9.03052C13.2715 9.41884 13.5863 9.73364 13.9746 9.73364Z",
    fill: "#E44F2E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M14.0625 9.64551C14.4508 9.64551 14.7656 9.33071 14.7656 8.94238C14.7656 8.55406 14.4508 8.23926 14.0625 8.23926C13.6742 8.23926 13.3594 8.55406 13.3594 8.94238C13.3594 9.33071 13.6742 9.64551 14.0625 9.64551Z",
    fill: "url(#paint14_radial_434_3390)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M19.6875 14.333C20.0758 14.333 20.3906 14.0182 20.3906 13.6299C20.3906 13.2416 20.0758 12.9268 19.6875 12.9268C19.2992 12.9268 18.9844 13.2416 18.9844 13.6299C18.9844 14.0182 19.2992 14.333 19.6875 14.333Z",
    fill: "url(#paint15_radial_434_3390)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    filter: "url(#filter9_f_434_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6465 10.9375C12.5521 10.9375 13.2871 11.6716 13.2871 12.5781C13.2871 13.0928 13.7043 13.51 14.2199 13.51C14.655 13.51 15.0723 13.6829 15.38 13.9905C15.6877 14.2982 15.8605 14.7155 15.8605 15.1506C15.8605 15.5857 15.6877 16.003 15.38 16.3107C15.0723 16.6184 14.655 16.7912 14.2199 16.7912C13.1024 16.7912 12.0307 16.3474 11.2405 15.5573C10.4502 14.7672 10.0061 13.6956 10.0059 12.5781C10.0059 11.6716 10.7399 10.9375 11.6465 10.9375Z",
    fill: "#D95B39"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7754 10.7949C12.682 10.7949 13.416 11.529 13.416 12.4355C13.416 12.9512 13.8341 13.3684 14.3488 13.3684C14.7839 13.3684 15.2012 13.5412 15.5089 13.8489C15.8166 14.1566 15.9895 14.5739 15.9895 15.009C15.9895 15.4441 15.8166 15.8614 15.5089 16.1691C15.2012 16.4768 14.7839 16.6496 14.3488 16.6496C13.2312 16.6496 12.1593 16.2056 11.369 15.4153C10.5787 14.625 10.1348 13.5532 10.1348 12.4355C10.1348 11.529 10.8698 10.7949 11.7754 10.7949Z",
    fill: "url(#paint16_radial_434_3390)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    filter: "url(#filter10_f_434_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M12.1582 11.9011C12.2116 12.3258 12.3691 13.2108 13.0366 13.8792C13.7051 14.5467 15.0288 14.5383 15.0288 14.5383",
    stroke: "url(#paint17_linear_434_3390)",
    strokeWidth: 0.703125,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    filter: "url(#filter11_f_434_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M4.02906 18.3324C3.71125 18.083 3.0625 17.2421 3.0625 16.3983C3.0625 14.7286 4.40969 14.304 4.40969 14.304",
    stroke: "url(#paint18_radial_434_3390)",
    strokeWidth: 0.234375,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    filter: "url(#filter12_f_434_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M26.6306 18.4786C26.9484 18.2002 27.5981 17.2618 27.5981 16.3196C27.5981 14.4558 26.25 13.9814 26.25 13.9814",
    stroke: "url(#paint19_radial_434_3390)",
    strokeWidth: 0.46875,
    strokeLinecap: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_434_3390",
    x: 1.8457,
    y: 12.7729,
    width: 6.25586,
    height: 7.39038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188,
    result: "effect1_foregroundBlur_434_3390"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_434_3390",
    x: 21.959,
    y: 12.4871,
    width: 6.42969,
    height: 7.91064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375,
    result: "effect1_foregroundBlur_434_3390"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_434_3390",
    x: 16.6621,
    y: 15.3726,
    width: 4.17578,
    height: 2.40283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188,
    result: "effect1_foregroundBlur_434_3390"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_434_3390",
    x: 12.9121,
    y: 18.2432,
    width: 4.17578,
    height: 2.40283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188,
    result: "effect1_foregroundBlur_434_3390"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_434_3390",
    x: 14.7949,
    y: 9.8208,
    width: 5.99805,
    height: 2.31567,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188,
    result: "effect1_foregroundBlur_434_3390"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_434_3390",
    x: 10.1445,
    y: 17.3066,
    width: 2.20312,
    height: 1.40625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188,
    result: "effect1_foregroundBlur_434_3390"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_434_3390",
    x: 8.2832,
    y: 14.6772,
    width: 1.875,
    height: 1.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188,
    result: "effect1_foregroundBlur_434_3390"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_434_3390",
    x: 18.623,
    y: 12.7842,
    width: 1.875,
    height: 1.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188,
    result: "effect1_foregroundBlur_434_3390"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_434_3390",
    x: 13.0371,
    y: 8.09302,
    width: 1.875,
    height: 1.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188,
    result: "effect1_foregroundBlur_434_3390"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_434_3390",
    x: 9.77148,
    y: 10.7031,
    width: 6.32422,
    height: 6.32251,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188,
    result: "effect1_foregroundBlur_434_3390"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_434_3390",
    x: 11.1035,
    y: 10.8464,
    width: 4.98047,
    height: 4.74658,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562,
    result: "effect1_foregroundBlur_434_3390"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_434_3390",
    x: 2.71094,
    y: 13.9524,
    width: 2.05078,
    height: 4.73169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188,
    result: "effect1_foregroundBlur_434_3390"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_434_3390",
    x: 25.7812,
    y: 13.5127,
    width: 2.28516,
    height: 5.43457,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188,
    result: "effect1_foregroundBlur_434_3390"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_434_3390",
    x1: 6.5625,
    y1: 15.7393,
    x2: 1.66969,
    y2: 15.7393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_434_3390",
    x1: 23.4375,
    y1: 16.4424,
    x2: 30.8203,
    y2: 16.4424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#8C8695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#898391",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_434_3390",
    x1: 6.35732,
    y1: 15.6811,
    x2: 1.69982,
    y2: 15.6811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B6999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#7F7098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#A59DB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_434_3390",
    x1: 23.9118,
    y1: 19.6655,
    x2: 23.9118,
    y2: 13.1611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAB4C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#D3D3D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B6BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_434_3390",
    x1: 6.5625,
    y1: 20.4268,
    x2: 23.4375,
    y2: 20.4268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#837C8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    stopColor: "#87799A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#9280AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAC7CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_434_3390",
    x1: 15,
    y1: 5.19238,
    x2: 15,
    y2: 22.5652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0CBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_434_3390",
    x1: 7.28023,
    y1: 10.9936,
    x2: 22.7049,
    y2: 10.9936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC1BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#A788A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A7079"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_434_3390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0196 13.2783) rotate(11.0621) scale(13.2839 9.98334)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#FF8144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B9462D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_434_3390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.6989 17.3799) rotate(-13.9317) scale(3.89384 3.89384)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE9A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFD53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF15A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_434_3390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4822 10.8174) rotate(92.0096) scale(1.67095 2.4281)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63BE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#64BF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55A649"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_434_3390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3628 11.1108) rotate(90) scale(1.74317 2.81155)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#7AD263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#619F39"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_434_3390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.225 18.3174) rotate(-13.9317) scale(1.94692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE9A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#FFD53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF15A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_434_3390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7314 19.2549) rotate(93.5215) scale(1.9079 2.77242)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63BE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#64BF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851,
    stopColor: "#4C9840"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_434_3390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.68605 15.3879) rotate(110.76) scale(0.877294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF877F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#F1412E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD3F25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_434_3390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.3732 8.82579) rotate(110.76) scale(0.877294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF877F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#F1412E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD3F25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_434_3390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9972 13.5119) rotate(110.76) scale(0.877294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF877F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#F1412E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD3F25"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_434_3390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.828 12.7522) rotate(101.107) scale(3.97278)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C86D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#B06446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#8B543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#8D482D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_434_3390",
    x1: 11.982,
    y1: 11.9011,
    x2: 14.8826,
    y2: 14.5383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#CF8B73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99A87"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_434_3390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.0625 16.5305) scale(2.88575 2.57813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEA6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACA5BB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_434_3390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.3935 15.9765) rotate(171.408) scale(3.94071 3.91298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E0E7",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentEmojiPotOfFood);
export default __webpack_public_path__ + "static/media/fluent-emoji_pot-of-food.ca3e1f05e9578355268c95f4ad154166.svg";
export { ForwardRef as ReactComponent };